'use strict';

function isEmbedded() {
    try {
        if (globalThis.self === globalThis.top) return false;
    } catch {
        return true;
    }

    const params = new globalThis.URLSearchParams(globalThis.location.search);
    return params.get('embed') === '1';
}

function isSameOrigin(url) {
    try {
        const parsed = new globalThis.URL(url, globalThis.location.href);
        return parsed.origin === globalThis.location.origin;
    } catch {
        return false;
    }
}

if (isEmbedded()) {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]');
        if (!link) return;

        const target = (link.target || '').toLowerCase();
        if (target && target !== '_self') return;

        // Precisa ser o valor bruto do atributo (não a propriedade .href, que resolve a URL) pra reconhecer âncoras, javascript: e afins.
        const href = link.getAttribute('href') || '';
        const hrefLower = href.toLowerCase();
        if (!href || hrefLower.startsWith('#') || hrefLower.startsWith('javascript:') || hrefLower.startsWith('mailto:') || hrefLower.startsWith('tel:')) return;

        if (!isSameOrigin(href)) return;

        const url = new globalThis.URL(href, globalThis.location.href);
        if (url.searchParams.get('embed') === '1') return;

        event.preventDefault();
        url.searchParams.set('embed', '1');
        globalThis.location.href = url.toString();
    }, true);
}
